import { GenericError, errorMessage } from '../../../../utils/errors';
import { fetchJSON } from '../../../../utils/fetch';

import { VehicleCatalogResponse } from '../../../../services/victor/config-start-response';
import { rootStore } from '../../../root-store';
import { featureAppStoreActions } from '../../feature-app-store';

// Why is this here? Because it is only used here.

interface ConfigStartInput {
	cacheKey?: string;
}

export async function fetchConfigStart({ cacheKey }: ConfigStartInput): Promise<VehicleCatalogResponse | undefined> {
	const victorServiceConfig = featureAppStoreActions.getServiceConfig('oneapi-victor');
	if (!victorServiceConfig) {
		errorMessage('Unable to get victorServiceConfig please check you are not in a no-victor market');
		return;
	}

	const [_, currentModelValue] = rootStore.currentModel.get();
	if (!currentModelValue) {
		errorMessage('Unable to get currentModel from store, please contact dev team');
		return;
	}

	const { carlineCode, salesgroupCode, trimName, tenant } = currentModelValue.vehicleConfiguration || {};

	const { urlPath, urlOrigin, credentials } = victorServiceConfig;

	const urlParams = new URLSearchParams({
		tenant: tenant || '',
		carlineKey: carlineCode || '',
		salesgroupKey: salesgroupCode || '',
		trimName: trimName || '',
		fetchPrices: 'false',
		fetchInvisible: 'false',
		fetchWltp: 'false',
		fetchFeatureCategoriesAndFamilies: 'true',
		mediaParameterSets: '[]',
		fetchMediaForConfiguration: 'false',
		fetchMediaForFeatures: 'true',
		fetchExpansion: 'false',
		addErrorMps: 'false'
	});

	if (cacheKey) {
		urlParams.set('cacheKey', cacheKey);
	}
	const vcsoPath = 'vcso/configStart';

	const url = `${urlOrigin}${urlPath || ''}/${vcsoPath}?${urlParams.toString()}`;

	const config = await fetchJSON<VehicleCatalogResponse>({ url, credentials });
	if (!config) {
		throw new GenericError(
			`Couldn't load vehicle configuration for carline ${carlineCode}, salesgroup ${salesgroupCode}, trimname ${trimName}.`
		);
	}

	return config;
}
